// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__RcnNy","roll":"style_roll__Q-NRv","colors":"style_colors__Wqx1v","i1":"style_i1__9N6UJ","i2":"style_i2__E6CfR","i3":"style_i3__D61MZ"};